module.exports = __webpack_public_path__ + "static/media/footer-linkedin.62ff9905.svg";